
import { Button } from "@/components/ui/button";
import { Copy, Trash2 } from "lucide-react";

interface ShareInfo {
  id: string;
  email: string;
  access_code: string;
  created_at: string;
}

interface SharesListProps {
  shares: ShareInfo[];
  isLoading: boolean;
  onCopyLink: (accessCode: string) => void;
  onDeleteShare: (shareId: string) => void;
}

const SharesList = ({ shares, isLoading, onCopyLink, onDeleteShare }: SharesListProps) => {
  if (isLoading) {
    return <p className="text-sm text-muted-foreground">Loading shares...</p>;
  }
  
  if (shares.length === 0) {
    return null;
  }
  
  return (
    <ul className="space-y-3">
      {shares.map((share) => (
        <li key={share.id} className="flex items-center justify-between gap-2 text-sm">
          <span className="truncate flex-1">{share.email}</span>
          <div className="flex items-center gap-2">
            <Button
              variant="ghost"
              size="icon"
              className="h-8 w-8"
              onClick={() => onCopyLink(share.access_code)}
            >
              <Copy className="h-4 w-4" />
              <span className="sr-only">Copy link</span>
            </Button>
            <Button
              variant="ghost"
              size="icon"
              className="h-8 w-8 text-destructive"
              onClick={() => onDeleteShare(share.id)}
            >
              <Trash2 className="h-4 w-4" />
              <span className="sr-only">Delete share</span>
            </Button>
          </div>
        </li>
      ))}
    </ul>
  );
};

export default SharesList;
